
import XHeader from 'vux/src/components/x-header/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'

import { mapState } from 'vuex'
export default {
name: 'car',
props: [],
components: {
XHeader,
Grid,
GridItem
},
data () {
return {
isEdit: this.$route.params.isEdit,
traffic: [
{
name: '飞机',
site: ['site1', 'site2'],
icon: 'airplane',
type: '1',
isShow: false
},
{
name: '火车',
site: ['site3', 'site4'],
icon: 'rail',
type: '2',
isShow: false
},
{
name: '汽车',
site: ['site5'],
icon: 'coach',
type: '3',
isShow: false
},
{
name: '其他',
site: null,
icon: 'autocar',
type: '4',
isShow: true
}
]
}
},
computed: {
...mapState({
token: state => state.token,
studentId: state => state.userInfo.id,
flowId: state => state.flowInfo.flowId,
flowType: state => state.flowInfo.flowType,
title: state => state.currentProcedureInfo.name,
flowProcedureId: state => state.currentProcedureInfo.flowProcedureId,
procedureId: state => state.currentProcedureInfo.procedureId,
parentRouter: state => state.currentProcedureInfo.parentRouter
}),
status () {
return this.$route.params.status
}
},
created () {},
mounted () {
this.getCarList()
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {

this.$router.push({
name: this.parentRouter
})
}, 300)
},
getCarList () {
let params = {
flowId: this.flowId,
flowProcedureId: this.flowProcedureId,
procedureId: this.procedureId
}
this.$api.get('/configWayToSchool', params,
r => {
this.airplane = r.data.filter(item => {
if (item.transportation === '1') {
return true
}
})
this.train = r.data.filter(item => {
if (item.transportation === '2') {
return true
}
})
this.car = r.data.filter(item => {
if (item.transportation === '3') {
return true
}
})
if (this.airplane.length > 0) {
this.traffic[0].isShow = true
}
if (this.train.length > 0) {
this.traffic[1].isShow = true
}
if (this.car.length > 0) {
this.traffic[2].isShow = true
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/car.vue